export const QUESTION_TYPES = {
  single: 'single-select',
  multiple: 'multiple-select',
  text: 'text',
} as const;

export const ANSWER_TYPES = {
  industries: 'industries',
  serviceTypes: 'service-types',
  custom: 'custom',
} as const;

export const CLOSED_STATE = 'closed';
export const ADD_QUESTION_STATE = 'addQuestion';
export const EDIT_QUESTION_STATE = 'editQuestion';
export const ADD_REMINDER_STATE = 'addReminder';
export const EDIT_REMINDER_STATE = 'editReminder';
